/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Typography from '../Typography';

const FormField = ({
  fullWidth = true,
  label = '',
  labelAriaHidden,
  ariaLabel,
  error,
  children,
  icon,
  divClassName,
  labelFor,
  labelClassName,
  labelTypographyType = 'h3',
  dense = false,
  onKeyPress,
}) => (
  <div
    className={clsx(
      'relative line-height-[24px] height-auto',
      fullWidth && 'w-full',
    )}
    onKeyPress={onKeyPress}
  >
    {label !== '' && (
      <div
        className={clsx(
          divClassName,
          dense ? 'mb-[3px]' : 'mb-[8px]',
          icon && 'flex flex-row flex-wrap items-center',
        )}
      >
        <Typography
          type={labelTypographyType}
          component="label"
          htmlFor={labelFor ? labelFor : children.props.id}
          ariaLabel={ariaLabel}
          ariaHidden={labelAriaHidden}
          className={clsx(
            'ml-[4px]',
            labelTypographyType !== 'h2' && '!text-legacy-textBody',
            labelClassName,
          )}
        >
          {label}
        </Typography>
        {icon}
      </div>
    )}
    {children}
    <div
      className={clsx(dense ? 'min-h-0' : 'min-h-[22px]', 'mx-[5px] mt-[-6px]')}
    >
      {error && (
        <Typography type="error" component="p">
          {error}
        </Typography>
      )}
    </div>
  </div>
);
FormField.propTypes = {
  fullWidth: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelAriaHidden: PropTypes.string,
  ariaLabel: PropTypes.string,
  error: PropTypes.string,
  children: PropTypes.any,
  icon: PropTypes.object,
  divClassName: PropTypes.string,
  labelFor: PropTypes.string,
  labelClassName: PropTypes.string,
  labelTypographyType: PropTypes.string,
  dense: PropTypes.bool,
};

export default FormField;
